var _ = require('lodash');
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="user-shouhu-page">\n    \n    <div class="app-content">\n        <div class="shouhu-special-block block">\n            <div class="title">'+
((__t=(UpAct.lang.template('贡献榜')))==null?'':__t)+
'</div>\n            <div class="content" id="SHOUHU-USER">\n                \n            </div>\n            \n        </div>  \n        <div class="shouhu-list block" id="J-USER-SHOUHU-LIST">\n            <div class="list-wrapper content" > \n                <div node-id="list"  data-params="'+
((__t=(params))==null?'':__t)+
'" ></div>\n                <div class="ui-tip hidden" node-id="loading">'+
((__t=(UpAct.lang.template('正在加载数据...')))==null?'':__t)+
'</div>\n                <div class="ui-tip hidden" node-id="end">'+
((__t=(UpAct.lang.template('没有更多数据了哦')))==null?'':__t)+
'</div>\n                <div class="ui-tip hidden" node-id="error">'+
((__t=(UpAct.lang.template('系统异常')))==null?'':__t)+
'</div>\n            </div>\n        </div>      \n    </div>\n    \n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));



//////////////////
// WEBPACK FOOTER
// ./js/component/shouhulist/shouhu.tmpl
// module id = 86
// module chunks = 0